import React, { useMemo } from 'react';
import { ContactPhone } from '../Meisterkachel/Contact';
import MapSelector from '../Map/MapSelector';
import { standortToMarker } from '../Map/markerHelper';
import CalculateRouteLink from '../Map/CalculateRouteLink';
import { navigateToSubLocation } from '../../../modules/actions/standort/subLocation';
import { useStandortHistory } from '../VHost/StandortHistory';
import ContactModal from '../Anfrage/ContactModal';
import Anchor from '../form-elements/Anchor';

function ContactTile({ location }) {
    const history = useStandortHistory();

    const renderTimeString = (timeString) => {
        if (!timeString) return null;
        const parts = timeString.split(' | ').filter(Boolean);
        return parts.map((part, index) => (
            <div key={index}>
                {part}
                {index < parts.length - 1 && <br />}
            </div>
        ));
    };

    const marker = useMemo(() => {
        const onClick = () => navigateToSubLocation({ history, subLocationUrl: location.subLocationUrl });
        return standortToMarker({ standort: location, onClick });
    }, [history, location]);

    const tileItems = [];

    if (location.anschrift) {
        tileItems.push({
            key: 'contact',
            content: (
                <div className='info-box uk-height-medium uk-overflow-auto'>
                    <div className='uk-margin-top uk-margin-left'>
                        <h3 className='uk-text-primary'>Kontakt</h3>

                        <div className='uk-flex uk-margin-small-bottom'>
                            <div className='uk-flex-none uk-margin-small-right' style={{ width: '24px' }}>
                                <i className='uk-text-primary' data-uk-icon="icon: location; ratio: 1" aria-hidden="true"></i>
                            </div>
                            <div className='uk-flex-1'>
                                {location.anschrift.strasse}<br />
                                {`${location.anschrift.plz} ${location.anschrift.ort}`}
                            </div>
                        </div>

                        <div className='uk-flex uk-margin-small-bottom'>
                            <div className='uk-flex-none uk-margin-small-right' style={{ width: '24px' }}>
                                <i className='uk-text-primary' data-uk-icon="icon: receiver; ratio: 1" aria-hidden="true"></i>
                            </div>
                            <div className='uk-flex-1'>
                                <ContactPhone
                                    modifier="link"
                                    hideIcon
                                    hideArrow
                                    phone={location.anschrift.telefon}
                                    className="uk-flex-left contact-tile-link"
                                />
                            </div>
                        </div>

                        <div className='uk-flex uk-margin-small-bottom'>
                            <div className='uk-flex-none uk-margin-small-right' style={{ width: '24px' }}>
                                <i className='uk-text-primary' data-uk-icon="icon: mail; ratio: 1" aria-hidden="true" />
                            </div>
                            <div className='uk-flex-1'>
                                <ContactModal>
                                    {({ openModal }) => (
                                        <button
                                            modifier="default"
                                            hideArrow
                                            className='uk-button uk-button-link uk-padding-remove uk-margin-remove contact-tile-link'
                                            onClick={openModal}
                                            ariaLabel="Kontaktformular öffnen"
                                        >
                                            {location.anschrift.email}
                                        </button>
                                    )}
                                </ContactModal>
                            </div>
                        </div>

                        <div className='uk-flex uk-margin-top'>
                            <div>
                                <CalculateRouteLink
                                    key={location._id}
                                    modifier="link"
                                    hideArrow
                                    label={location.subLocationUrl}
                                    location={location.subLocationUrl}
                                    lng={marker.lng}
                                    lat={marker.lat}
                                    ariaLabel={`Route berechnen zu ${location.anschrift?.firma || 'Standort'}`}
                                >
                                    <button className='uk-button uk-button-primary'>
                                        Route Planen
                                    </button>
                                </CalculateRouteLink>
                            </div>
                        </div>
                    </div>
                </div>
            ),
        });
    }

    tileItems.push({
        key: 'open-hours',
        content: (
            <div className='info-box uk-height-medium uk-overflow-auto'>
                <div className='uk-margin-top uk-margin-left'>
                    <h3 className='uk-text-primary'>Öffnungszeiten</h3>

                    {location.oeffnungszeiten && (
                        <div>
                            <h4 className='uk-text-primary'>Verkauf</h4>
                            <div className='time-string-wrapper'>
                                {renderTimeString(location.oeffnungszeiten)}
                            </div>
                        </div>
                    )}
                    <hr />
                    {location.hotline && (
                        <div>
                            <h4 className='uk-text-primary'>Service</h4>
                            <div className='time-string-wrapper'>
                                {renderTimeString(location.hotline)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        ),
    });

    tileItems.push({
        key: 'map',
        content: (
            <div className="info-box uk-height-medium uk-overflow-hidden map-box">
                <div className="uk-height-1-1">
                    <MapSelector markers={[marker]} hideMarkerPosition maxHeight="100%" />
                </div>
            </div>
        ),
    });

    return (
        <div>
            <div className="uk-grid-medium uk-grid-match uk-child-width-1-1 uk-child-width-1-3@m uk-visible@m" data-uk-grid>
                {tileItems.map(tile => (
                    <div key={`${tile.key}-grid`}>
                        {tile.content}
                    </div>
                ))}
            </div>

            <div className="uk-hidden@m">
                <div className="uk-slider uk-position-relative uk-visible-toggle" tabIndex={-1} data-uk-slider="finite: true">
                    <ul className="uk-slider-items uk-grid uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s">
                        {tileItems.map(tile => (
                            <li key={`${tile.key}-mobile`}>
                                {tile.content}
                            </li>
                        ))}
                    </ul>

                    <Anchor className="uk-position-center-left uk-visible-toggle tile-button" data-uk-slider-item="previous" ariaLabel="Vorherige Box" role="button" tabIndex="0">
                        <i data-uk-slidenav-previous="" aria-hidden="true" />
                    </Anchor>
                    <Anchor className="uk-position-center-right uk-visible-toggle tile-button" data-uk-slider-item="next" ariaLabel="Nächste Box" role="button" tabIndex="0">
                        <i data-uk-slidenav-next="" aria-hidden="true" />
                    </Anchor>
                </div>
            </div>
        </div>
    );
}

export default ContactTile;

